import React from "react";
import dayjs from "dayjs";
import { ChantInput } from "../../../../../../CommonComponents";
import { TIME_FORMAT } from "../utils/constants";
import "../styles/eventFormStyles.css";
import ChantDatePicker from "../../../../../../CommonComponents/ChantDatePicker/ChantDatePicker";
import ChantTimePicker from "../../../../../../CommonComponents/ChantTimePicker/ChantTimePicker";
import useContentFormParams from "../hooks/useContentFormParams";

export const BasicFieldsSection = ({
  title,
  author,
  eventStartDate,
  eventStartTime,
  onTitleChange,
  onAuthorChange,
  onDateChange,
  onTimeChange,
  isAnnouncementType,
  control,
}) => {
  const { formMode } = useContentFormParams();
  const eventStartDateValue = eventStartDate
    ? dayjs.unix(eventStartDate)
    : null;

  return (
    <>
      <div className="event-form-field-wrapper" style={{ width: "100%" }}>
        <ChantInput
          label="Title"
          required={isAnnouncementType}
          value={title}
          onChange={onTitleChange}
          placeholder="Season Kickoff Party"
          disabled={formMode === "view"}
          control={control}
          name="title"
        />
      </div>

      {isAnnouncementType && (
        <div className="event-form-field-wrapper" style={{ width: "100%" }}>
          <ChantInput
            label="Author Name"
            value={author}
            onChange={onAuthorChange}
            placeholder="Lisa Smith"
            disabled={formMode === "view"}
            control={control}
            name="author"
          />
        </div>
      )}

      <div className="event-form-field-wrapper" style={{ width: "100%" }}>
        <ChantDatePicker
          required={true}
          label="Date"
          value={eventStartDateValue}
          onChange={onDateChange}
          disabledDate={(current) =>
            current && current < dayjs().startOf("day")
          }
          disabled={formMode === "view"}
        />
      </div>
      <div className="event-form-field-wrapper" style={{ width: "100%" }}>
        <ChantTimePicker
          label="Time"
          required={!isAnnouncementType}
          value={eventStartTime}
          defaultOpenValue={dayjs().set("hour", 0).set("minute", 0)}
          onChange={onTimeChange}
          format={TIME_FORMAT}
          disabled={formMode === "view"}
        />
      </div>
    </>
  );
};
